export default "__VITE_ASSET__f98fa170__"